module.exports = __webpack_public_path__ + "static/media/grabaseat4_preview.bf117121.jpg";